import {BaseCriteriaModel} from './base-criteria.model';
import {Optional} from 'typescript-optional';

export class FinancialItemQueryCriteriaClass extends BaseCriteriaModel {
  //for the header(s)
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  category?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();
  value_numeric?: Optional<number> = Optional.empty();
  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/

  //for the extension(s)
  param_name?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  item_hdr_guid?: Optional<string> = Optional.empty();

  //for the line(s)
  line_code?: Optional<string> = Optional.empty();
  hdr_guid?: Optional<string> = Optional.empty();

}

export class FinancialItemCriteriaModelQuery {
  query = '';

  constructor(financialItemCriteriaModel: FinancialItemQueryCriteriaClass) {

    if (!financialItemCriteriaModel) {
      return;
    }

    this.query += financialItemCriteriaModel.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += financialItemCriteriaModel.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += financialItemCriteriaModel.category.filter(x => x !== '').map(x => '&category=' + x).orElse('');
    this.query += financialItemCriteriaModel.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += financialItemCriteriaModel.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += financialItemCriteriaModel.value_numeric.filter(x => x !== null).map(x => '&value_numeric=' + x).orElse('');

    this.query += financialItemCriteriaModel.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += financialItemCriteriaModel.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += financialItemCriteriaModel.item_hdr_guid.filter(x => x !== '').map(x => '&item_hdr_guid=' + x).orElse('');

    this.query += financialItemCriteriaModel.line_code.filter(x => x !== '').map(x => '&line_code=' + x).orElse('');
    this.query += financialItemCriteriaModel.hdr_guid.filter(x => x !== '').map(x => '&hdr_guid=' + x).orElse('');
    this.query += financialItemCriteriaModel.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');

    this.query += '&status=' + financialItemCriteriaModel.status;
    this.query += '&orderBy=' + financialItemCriteriaModel.orderBy;
    this.query += '&order=' + financialItemCriteriaModel.order;
    this.query += '&offset=' + financialItemCriteriaModel.offset + '&limit=' + financialItemCriteriaModel.limit;
  }
}
